import Vue from 'vue'
import Vuex from 'vuex'
import {AppState} from '@/store/modules/app'
import {AsixState} from '@/store/modules/asix'

Vue.use(Vuex)

export interface RootState {
  app: AppState,
  asix: AsixState,
}

export default new Vuex.Store<RootState>({})
